// extracted by mini-css-extract-plugin
module.exports = {"star":"_3v8CJFWdTN1JrwNay4YC-v","star-on":"r46KAnQMsLN-kFyJB6QJQ","star-off":"_2uAFzRG1N1AmGVczjJ2NkT"};